module.exports = __webpack_public_path__ + "static/media/support20_large_banner.d700c4d9.jpg";